import { api } from "@/store/api";
import {
  IGetEnumsResponseBody,
  IGetFileRequestBody,
  IPaymentAccountsResponseBody,
} from "@/features/app/types";

const API_PREFIX = "/app";

const appApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getEnums: builder.query<IGetEnumsResponseBody, void>({
      query: (params) => ({
        url: `${API_PREFIX}/enums`,
      }),
    }),
    getFile: builder.query<Blob, IGetFileRequestBody>({
      query: ({ token }) => ({
        url: `file/file/${token}`,
        responseHandler: (response) => response?.blob(),
      }),
    }),
    getPaymentAccounts: builder.query<IPaymentAccountsResponseBody, void>({
      query: () => ({
        url: `${API_PREFIX}/payment-accounts`,
      }),
    }),
  }),
  overrideExisting: false,
});
export const {
  useGetEnumsQuery,
  useLazyGetFileQuery,
  useGetPaymentAccountsQuery,
} = appApi;
